/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PoweredBy/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import GreyfinchBird from 'DesignSystem/Svgs/GreyfinchBird/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PoweredBy({
  children,
  viewPath = "/App/Account/Content/Content/Home/PoweredBy"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="PoweredBy.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<GreyfinchBird
  viewPath={`${viewPath}/GreyfinchBird`}
 width={14}
 height={14}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={10}
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral600}
 text="Powered by Greyfinch"
/>
</div>
{children}
</React.Fragment>)
}